import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { getActiveShopId } from '../../auth/selectors';
import styles from './styles.module.scss';
import { useSession } from '../../../modules/infra/session';
import config from '../../../config';
import { PhoneAgentAuthQuery } from './network/phone-agent-auth-query';
import { LoadingOverlay } from '../../../modules/shared/engage/campaign-builder/components/loading-overlay';
import SimpleHeader from '../headers/simpleHeader';
var PhoneAgent = function () {
    var _a, _b, _c, _d;
    var session = useSession().data;
    var email = (_d = (_c = (_b = (_a = session === null || session === void 0 ? void 0 : session.user) === null || _a === void 0 ? void 0 : _a.shops) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.email) !== null && _d !== void 0 ? _d : '';
    var shopId = useSelector(getActiveShopId);
    var phoneAgentAuthQuery = new PhoneAgentAuthQuery();
    var _e = useQuery(phoneAgentAuthQuery.getKey({ shopId: shopId, email: email }), function () { return phoneAgentAuthQuery.request({ shopId: shopId, email: email }); }, {
        enabled: !!shopId,
        cacheTime: 0,
        staleTime: 0,
    }), authData = _e.data, isLoading = _e.isLoading;
    var src = "".concat(config.phoneAgentUrl, "/app/embed?authToken=").concat((authData === null || authData === void 0 ? void 0 : authData.authToken) || '', "&email=").concat(email, "&customerId=").concat(shopId);
    if (isLoading) {
        return _jsx(LoadingOverlay, {});
    }
    return (_jsxs("div", { className: "c-wrapper-allow-header", children: [_jsx(SimpleHeader, { heading: _jsx("span", { className: styles['page-header'], children: _jsx("span", { children: "Phone Agent" }) }) }), _jsx("div", { className: styles.container, children: _jsx("iframe", { title: "Phone Agent Dashboard", className: styles.iframe, src: src }) })] }));
};
export default PhoneAgent;
